import { render } from "./IoTShadowRulesTable.vue?vue&type=template&id=58b95995&scoped=true"
import script from "./IoTShadowRulesTable.vue?vue&type=script&lang=js"
export * from "./IoTShadowRulesTable.vue?vue&type=script&lang=js"

import "./IoTShadowRulesTable.vue?vue&type=style&index=0&id=58b95995&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b95995"]])

export default __exports__